import { Component } from '@angular/core'

@Component({
  selector: 'cover-delete',
  templateUrl: './delete-address.component.html',
  styleUrls: ['./delete-address.component.scss'],
})
export class DeleteAddressComponent {}
